import { render, staticRenderFns } from "./BalanceAdjustment.vue?vue&type=template&id=1936e9e4&scoped=true&"
import script from "./BalanceAdjustment.vue?vue&type=script&lang=js&"
export * from "./BalanceAdjustment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1936e9e4",
  null
  
)

export default component.exports